import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { IconTypes } from './icons.types';
import DirectionsWalk from '@material-ui/icons/DirectionsWalk';
import Add from '@material-ui/icons/Add';
import AddCircle from '@material-ui/icons/AddCircle';
import ListAltSharpIcon from '@material-ui/icons/ListAltSharp';
import PhoneIcon from '@material-ui/icons/Phone';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import MailIcon from '@material-ui/icons/Mail';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CheckIcon from '@material-ui/icons/Check';
import Loop from '@material-ui/icons/Loop';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import LocalAtm from '@material-ui/icons/LocalAtm';
import RepeatIcon from '@material-ui/icons/Repeat';
import LoopIcon from '@material-ui/icons/Loop';
import WarningIcon from '@material-ui/icons/Warning';

/**
 * DESIGN-V2
 */
import MenuBookIcon from '@material-ui/icons/MenuBook';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
// import AutoGraphIcon from '@material-ui/icons/autograph'; //Reports icon v5
import ShowChartIcon from '@material-ui/icons/ShowChart';
import NewReleasesOutlinedIcon from '@material-ui/icons/NewReleasesOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import LaunchIcon from '@material-ui/icons/Launch';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Timer from '@material-ui/icons/Timer';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import WifiOnIcon from '@material-ui/icons/Wifi';
import RssFeedIcon from '@material-ui/icons/RssFeed';
import LocationIcon from '@material-ui/icons/LocationOn';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import RestoreIcon from '@material-ui/icons/Restore';
import UpdateIcon from '@material-ui/icons/Update';

// Customer tab
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';

//Booking summary
import DateRangeIcon from '@material-ui/icons/DateRange';
import ScheduleIcon from '@material-ui/icons/Schedule';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import TimerIcon from '@material-ui/icons/Timer';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
import AppsIcon from '@material-ui/icons/Apps';
import RoomServiceIcon from '@material-ui/icons/RoomService';
// new customer form
import LocationCityIcon from '@material-ui/icons/LocationCity';
import BusinessIcon from '@material-ui/icons/Business';
import CakeIcon from '@material-ui/icons/Cake';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import AddIcCallOutlinedIcon from '@material-ui/icons/AddIcCallOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import DesktopMacOutlinedIcon from '@material-ui/icons/DesktopMacOutlined';

// needs svg-inline-loader configured in Webpack to work, or else you'll just get a url (these icons come from mui5)
const TableSVG = require('/images/mui5-icons/table_restaurant.svg');
const PaymentsSVG = require('/images/mui5-icons/payments.svg');
const DiningSVG = require('/images/mui5-icons/dining.svg');
const RoomSVG = require('/images/mui5-icons/room.svg');
const AbcSVG = require('/images/mui5-icons/abc.svg');
const TiconSVG = require('/images/mui5-icons/T-icon.svg');
const DrawerSVG = require('/images/mui5-icons/drawer-icon.svg');
const ArrowDownSVG = require('/images/mui5-icons/keyboardDoubleArrowDownIcon.svg');
const PersonSearchSVG = require('/images/mui5-icons/person_search.svg');
const GroupSVG = require('/images/mui5-icons/group.svg');
// import TableSVG from 'mui5-icons/table_restaurant.svg';
// import PaymentsSVG from 'mui5-icons/payments.svg';
// import DiningSVG from 'mui5-icons/dining.svg';
// import RoomSVG from 'mui5-icons/room.svg';
// import AbcSVG from 'mui5-icons/abc.svg';
// import TiconSVG from 'mui5-icons/T-icon.svg';
// import DrawerSVG from 'mui5-icons/drawer-icon.svg';

/**
 * Single-colour Google "G" glyph (NOT the multicolour brand mark) so it tints
 * to match the surrounding monochrome icons via `currentColor`.
 */
// eslint-disable-next-line react/display-name
const GoogleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-7 -7 62 62">
    <path d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" />
  </SvgIcon>
);

export default class IconsService {
  static getIcon(iconType: IconTypes): (props: SvgIconProps) => JSX.Element {
    switch (iconType) {
      case IconTypes.walkIn:
        return DirectionsWalk;

      case IconTypes.add:
        return Add;

      case IconTypes.addCircle:
        return AddCircle;

      case IconTypes.standbyList:
        return ListAltSharpIcon;

      case IconTypes.phone:
        return PhoneIcon;

      case IconTypes.phoneInTalk:
        return PhoneInTalkIcon;
  
      case IconTypes.mail:
        return MailIcon;

      case IconTypes.lock:
        return LockIcon;

      case IconTypes.unlock:
        return LockOpenIcon;

      case IconTypes.tick:
        return CheckIcon;

      case IconTypes.loading:
        return Loop;

      /**
       * DESIGN-V2
       */
      case IconTypes.bookings:
        return MenuBookIcon;
      case IconTypes.customers:
        return GroupOutlinedIcon;
      case IconTypes.reports:
        return ShowChartIcon; // to-do, in mui v5, replace with AutoGraphIcon
      case IconTypes.new:
        return NewReleasesOutlinedIcon;
      case IconTypes.settings:
        return SettingsOutlinedIcon;
      case IconTypes.admin:
        return LaunchIcon;
      case IconTypes.fullScreen:
        return FullscreenIcon;
      case IconTypes.fullscreenExit:
        return FullscreenExitIcon;
      case IconTypes.restore:
        return RestoreIcon;
      case IconTypes.update:
        return UpdateIcon;

      case IconTypes.stepperLeft:
        return KeyboardArrowLeftIcon;
      case IconTypes.stepperRight:
        return KeyboardArrowRightIcon;

      case IconTypes.autoRenewIcon:
        return AutorenewIcon;

      case IconTypes.timer:
        return Timer;

      case IconTypes.callOutlinedIcon:
        return CallOutlinedIcon;
      case IconTypes.accountBoxOutlinedIcon:
        return AccountBoxOutlinedIcon;
      case IconTypes.mailOutlineIcon:
        return MailOutlineIcon;
      case IconTypes.visibilityOutlinedIcon:
        return VisibilityOutlinedIcon;
      case IconTypes.visibilityOffOutlinedIcon:
        return VisibilityOffOutlinedIcon;
        case IconTypes.personOutlineIcon:
        return PersonOutlineIcon;

      case IconTypes.dateRangeIcon:
        return DateRangeIcon;
      case IconTypes.scheduleIcon:
        return ScheduleIcon;
      case IconTypes.restaurantIcon:
        return RestaurantIcon;
      case IconTypes.timerIcon:
        return TimerIcon;
      case IconTypes.eventSeatIcon:
        return EventSeatIcon;
      case IconTypes.localOfferOutlinedIcon:
        return LocalOfferOutlinedIcon;
      case IconTypes.serverOff:
        return WifiOffIcon; // to-do, in mui v5, replace with AutoGraphIcon
      case IconTypes.serverOn:
        return DesktopMacOutlinedIcon;
      case IconTypes.rss:
        return RssFeedIcon;
      case IconTypes.phoneForwardedIcon:
        return PhoneForwardedIcon;
      case IconTypes.googleIcon:
        return GoogleIcon;
      case IconTypes.location:
        return LocationIcon;
      case IconTypes.apps:
        return AppsIcon;
      case IconTypes.repeatServiceIcon:
        return RoomServiceIcon;
      case IconTypes.repeat:
        return RepeatIcon;
      case IconTypes.loop:
        return LoopIcon;
      case IconTypes.warning:
        return WarningIcon;
      case IconTypes.group:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: GroupSVG }} />
        );

      case IconTypes.tIcon:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: TiconSVG }} />
        );
      case IconTypes.drawer:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: DrawerSVG }} />
        );
      case IconTypes.money:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: PaymentsSVG }} />
        );
      case IconTypes.table:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: TableSVG }} />
        );
      case IconTypes.section:
        // eslint-disable-next-line react/display-name
        return () => <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: RoomSVG }} />;
      case IconTypes.bookingOptions:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: DiningSVG }} />
        );
      case IconTypes.abc:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className={'embeded-abc'} dangerouslySetInnerHTML={{ __html: AbcSVG }} />
        );
      case IconTypes.arrowDown:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className={'embeded-abc'} dangerouslySetInnerHTML={{ __html: ArrowDownSVG }} />
        );

      case IconTypes.personSearch:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className={'embeded-svg'} dangerouslySetInnerHTML={{ __html: PersonSearchSVG }} />
        );

      /**
       * New customer form
       */
      case IconTypes.locationCityIcon:
        return LocationCityIcon;
      case IconTypes.businessIcon:
        return BusinessIcon;
      case IconTypes.cakeIcon:
        return CakeIcon;
      case IconTypes.locationOnOutlinedIcon:
        return LocationOnOutlinedIcon;
      case IconTypes.addIcCallOutlinedIcon:
        return AddIcCallOutlinedIcon;
      case IconTypes.drawer:
        // eslint-disable-next-line react/display-name
        return () => (
          <span className="embeded-svg" dangerouslySetInnerHTML={{ __html: DrawerSVG }} />
        );
    }

    return null;
  }
}
